import InfoSVG from "@design-system/ui-icons/vanilla/Info"
import { createIcon } from "../createIcon"

export const InfoIcon = createIcon(InfoSVG)
